import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-l pb-xs border-gray-200 border-b-2 flex items-center justify-between" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { key: 1 }

import RoundedCard from "@/components/RoundedCard.vue";
import { encryptMsg, bytesToHex } from "@/helpers/encryption";
import { ref, onMounted } from "vue";

import { useSessionStore } from "@/store/sessionStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import { supabase } from "@/helpers/supabase";
import IconButton from "@/components/IconButton.vue";
import DialogCard from "@/components/DialogCard.vue";
import { useNotificationStore } from "@/store/notificationStore";
import { useMedicationsStore } from "@/store/medicationsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'FtpSettingsCard',
  props: {
    isOwnerOfSelectedCareProviderGroup: { type: Boolean }
  },
  setup(__props: any) {

const sessionStore = useSessionStore();
const medicationStore = useMedicationsStore();

const showFtpSettings = ref<boolean>(false);

const props = __props;

// FTP
const ftpModel = ref<any>({});
async function saveFtp() {
  if (sessionStore.selectedCareProviderGroup != null) {
    let encryptedObj = await encryptMsg({
      message: JSON.stringify(ftpModel.value),
      serverCareProviderGroupId: sessionStore.selectedCareProviderGroup.id,
      clientCareProviderGroupId: sessionStore.selectedCareProviderGroup.id,
      creatorCareProviderGroupId: sessionStore.selectedCareProviderGroup.id,
    });
    if (encryptedObj.clientKeyId != encryptedObj.serverKeyId) {
      alert("Keys sind nicht synchron. Fehler.");
      return;
    }
    try {
      let res = await supabase.functions.invoke("setFtp", {
        body: {
          host: ftpModel.value.host,
          username: ftpModel.value.username,
          password: ftpModel.value.password,
          encryptedConnection: bytesToHex(encryptedObj.encryptedMsg),
          nonce: bytesToHex(encryptedObj.nonce),
          careProviderGroupId: sessionStore.selectedCareProviderGroup.id,
          usedKey: encryptedObj.clientKeyId,
        },
      });
      if (res.error) {
        useNotificationStore().notifications.push({
          msg: `Fehler - FTP-Verbindung konnte nicht hergestellt werden. Überprüfen Sie das Passwort. #ftp01: ${res.error}`,
          type: "danger",
        });
        window._paq.push(["trackEvent", "FTPSettings", "error", 1]);
        return;
      }
    } catch (e) {
      useNotificationStore().notifications.push({
        msg: `Fehler - FTP-Verbindung konnte nicht gespeichert werden. #ftp02: ${e}`,
        type: "danger",
      });
      window._paq.push(["trackEvent", "FTPSettings", "error", 2]);

      return;
    }

    await sessionStore.loadFtpSettings();
    if (sessionStore.ftp) {
      ftpModel.value = sessionStore.ftp;
    }
    window._paq.push(["trackEvent", "FTPSettings", "saved", undefined]);

    medicationStore.updateShopMedicationInformation(true);

    showFtpSettings.value = false;
  }
}

onMounted(() => {
  if (sessionStore.ftp) {
    ftpModel.value = JSON.parse(JSON.stringify(sessionStore.ftp));
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      _unref(sessionStore).selectedCareProviderGroup?.is_shop &&
      props.isOwnerOfSelectedCareProviderGroup
    )
      ? (_openBlock(), _createBlock(RoundedCard, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(UmanaHeadline, { h: "h2" }, {
                default: _withCtx(() => [
                  _createTextVNode("FTP-Einstellungen")
                ]),
                _: 1
              }),
              _createVNode(IconButton, {
                icon: "pen",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showFtpSettings.value = true))
              })
            ]),
            (_unref(sessionStore).ftp)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createTextVNode(" Es sind folgende FTP-Anmeldedaten hinterlegt:"),
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(_unref(sessionStore).ftp.username) + " @ " + _toDisplayString(_unref(sessionStore).ftp.host), 1)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, "Es wurde bisher kein FTP-Server verknüpft."))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(DialogCard, {
      color: "gray",
      "is-visible": showFtpSettings.value,
      "show-footer": false,
      title: "FTP-Einstellungen",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showFtpSettings.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "form",
          onSubmit: saveFtp,
          modelValue: ftpModel.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ftpModel).value = $event)),
          "submit-label": "FTP-Server speichern"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              type: "text",
              placeholder: "Host",
              label: "Host",
              name: "host",
              help: "ohne ftp://",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              placeholder: "Nutzername",
              label: "FTP-Nutzername",
              name: "username",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "password",
              placeholder: "FTP-Passwort",
              label: "Passwort",
              name: "password",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              placeholder: "Dateiname der ProPharma Artikelliste",
              label: "Dateiname der Artikelliste",
              name: "articleListFileName",
              help: "mit Dateiendung",
              validation: "required"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["is-visible"])
  ], 64))
}
}

})